var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.formWorkOrderLoading,
          expression: "formWorkOrderLoading",
        },
      ],
      staticClass: "add-container",
    },
    [
      _c("el-page-header", {
        staticClass: "mb-10 fw-bold",
        attrs: { content: "工单详情" },
        on: { back: _vm.goBack },
      }),
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "fw-bold" }, [_vm._v("基本信息")]),
              _c(
                "el-tag",
                {
                  staticStyle: { float: "right" },
                  attrs: {
                    type: _vm.detail.baseData.status ? "info" : "",
                    effect: "dark",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.detail.baseData.status === 1 ? "已关闭" : "处理中"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "工单编码：" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.detail.baseData.code))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "工单名称：" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.detail.baseData.name))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "触发问卷：" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.detail.baseData.formName)),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "处理人：" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.detail.baseData.transactorName)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "品牌：" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.detail.baseData.brandName)),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "大区：" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.detail.baseData.parentPartitionName)
                          ),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "分区：" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.detail.baseData.locatedPartitionName)
                          ),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "门店：" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.detail.baseData.shopName)),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "组织编码：" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.detail.baseData.shopCode)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "box-card", attrs: { shadow: "never" } }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", { staticClass: "fw-bold" }, [_vm._v("触发内容")]),
            _c(
              "el-button",
              {
                staticStyle: { float: "right", padding: "3px 0" },
                attrs: { type: "text" },
                on: { click: _vm.handleClickToFormDetail },
              },
              [_vm._v("查看答卷详情 >")]
            ),
          ],
          1
        ),
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.detail.baseData.triggerReason) },
        }),
      ]),
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", { staticClass: "fw-bold" }, [_vm._v("工单日志")])]
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.detail.processingLogs } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "操作人",
                  align: "center",
                  prop: "transactorName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作类型",
                  align: "center",
                  prop: "operationType",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("operationTypeToText")(row.operationType)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "备注", align: "center", prop: "submessage" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作时间",
                  align: "center",
                  prop: "createTime",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.detail.baseData.status === 0
        ? _c(
            "div",
            { staticClass: "detail-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary", plain: "" },
                  on: { click: _vm.addRecord },
                },
                [_vm._v(" 添加处理记录 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.openCloseOrderConfirm },
                },
                [_vm._v(" 关闭工单 ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("order-operator", {
        ref: "recordForm",
        attrs: { title: "处理记录", closeOrderFormRule: _vm.recordFormRule },
        on: { handleConfirm: _vm.handleConfirmAddRecord },
      }),
      _c("order-operator", {
        ref: "closeReasonForm",
        attrs: {
          title: "关闭工单",
          closeOrderFormRule: _vm.closeOrderFormRule,
        },
        on: { handleConfirm: _vm.handleCloseOrderConfirm },
      }),
      _vm.formModelItem.formData && _vm.formKey
        ? _c("ViewOrUpdate", {
            ref: "viewOrUpdateDialog",
            attrs: {
              fields: _vm.formModelItem.formFields,
              "fixed-fields": _vm.fixedFields,
              "form-key": _vm.formKey,
              "form-model": _vm.formModelItem.formData,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }